package com.upcominds.expedite.features.splash

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.upcominds.expedite.data.auth.AuthRepository
import com.upcominds.expedite.data.mobilelogs.logMobileError
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

sealed class AuthCheckState {
    object Loading : AuthCheckState()
    object Authenticated : AuthCheckState()
    object Unauthenticated : AuthCheckState()
}

class SplashViewModel(
    private val authRepository: AuthRepository
) : ViewModel() {

    private val _authCheckState = MutableStateFlow<AuthCheckState>(AuthCheckState.Loading)
    val authCheckState = _authCheckState.asStateFlow()

    fun checkAuthenticationStatus() {
        viewModelScope.launch {
            _authCheckState.value = AuthCheckState.Loading
            // Optional: small delay so splash is visible
            delay(800L)
            try {
                val loggedIn = authRepository.isLoggedIn()
                _authCheckState.value = if (loggedIn) AuthCheckState.Authenticated else AuthCheckState.Unauthenticated
            } catch (e: Exception) {
                logMobileError("SplashViewModel.checkAuthenticationStatus", e)
                // In case of errors assume not authenticated
                _authCheckState.value = AuthCheckState.Unauthenticated
            }
        }
    }
}
